export const SET_UNREAD_MSG = 'SET_UNREAD_MSG';
export const SET_SELECTED_INSTRUCTOR = 'SET_SELECTED_INSTRUCTOR'